import React from 'react';
import PropTypes from 'prop-types';
import './panels.css';

// Centred lead-in heading + body for a section. Reusable: pass `title` and
// `body` as strings or nodes (title accepts JSX so a <br/> line break works).
const SectionIntro = ({ title, body }) => (
  <div className="sd-intro">
    <h2>{title}</h2>
    <p>{body}</p>
  </div>
);

SectionIntro.propTypes = {
  title: PropTypes.node.isRequired,
  body: PropTypes.node.isRequired,
};

export default SectionIntro;
